import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Highcharts from 'highcharts'
import StyledHighcharts, { tooltipStyle } from './StyledHighcharts'

import moment from 'moment-wrapper'

const MiniChart = ({ config, data }) => {
  const [chartOptions, setChartOptions] = useState({
    chart: {
      type: 'column',
      spacing: [0, 0, 0, 0],
    },

    tooltip: {
      ...tooltipStyle,
      outside: true,
      formatter: function (tooltip) {
        const date = Highcharts.dateFormat('%d %m %Y %H:%M', this.x)
        const line1 = moment(date, 'DD MM YYYY HH:mm').format('LLL') + ' ' + config.displayTimezone
        const line2 = `<br/> Tickets: <b>${this.y}</b>`
        return line1 + line2
      },
    },

    plotOptions: {
      series: {
        minPointLength: 2,
        pointPadding: 0,
        groupPadding: 0,
        dataLabels: { enabled: false },
      },
    },

    xAxis: {
      visible: true,
      type: 'datetime',
      labels: {
        enabled: false,
      },
      tickLength: 1,
      lineWidth: 1,
      lineColor: '#E6E6E6',
    },

    yAxis: { visible: false },
    legend: { enabled: false },
    credits: { enabled: false },
    title: { text: undefined },
    accessibility: { enabled: false },
  })

  useEffect(() => {
    updateSeries()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    updateSeries()
  }, [data]) // eslint-disable-line react-hooks/exhaustive-deps

  const updateSeries = () => {
    setChartOptions({
      ...chartOptions,
      ...{
        series: data,
      },
    })
  }

  return (
    <StyledHighcharts
      highcharts={Highcharts}
      containerProps={{
        style: {
          width: '100%',
          height: '100%',
        },
      }}
      options={chartOptions}
    />
  )
}

MiniChart.propTypes = {
  config: PropTypes.shape({
    displayTimezone: PropTypes.string.isRequired,
  }),
  data: PropTypes.object,
}

export default MiniChart
